import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNode,
  faHtml5,
} from "@fortawesome/free-brands-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";
import { faCloud, faGlobe, faTools } from "@fortawesome/free-solid-svg-icons";

const labelsFirst = ["JavaScript", "Python"];

const labelsSecond = [
  "React",
  "NextJs",
  "TailwindCSS",
  "HTML5",
  "CSS3",
  "Bootstrap",
];

const labelsThird = [
  "NodeJs",
  "Express",
  "AdonisJs",
  "MongoDB",
  "PostgreSQL",
  "MySQL",
];

const labelsFourth = ["Git", "VsCode", "Postman", "GitHub", "GitLab"];

const labelsFifth = ["AWS", "Vercel", "Heroku", "Vultr"];

// const labelsFirst = [
//   "React",
//   "TypeScript",
//   "JavaScript",
//   "HTML5",
//   "CSS3",
//   "SASS",
//   "Python",
//   "SQL",
//   "MongoDB",
//   "PostgreSQL",
//   "Postman",
// ];

// const labelsSecond = [
//   "Git",
//   "GitHub Actions",
//   "Vercel",
//   "AWS",
//   "Vultr",
//   "Heroku",
//   "Linux",
//   "Pandas",
//   "Selenium",
// ];

// const labelsThird = [
//   "OpenAI",
//   "Groq",
//   "LangChain",
//   "Qdrant",
//   "Hugging Face",
//   "LlamaIndex",
//   "Streamlit",
// ];

function Expertise() {
  return (
    <div
      className="container"
      id="expertise"
    >
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon
              icon={faGlobe}
              size="3x"
            />
            <h3>Languages</h3>
            {/* <p>
              With experience as a Product Owner and having taken various
              backend, frontend, and fullstack courses, I have built several web
              applications from scratch using technologies such as React,
              Next.js, Express, and AdonisJS. This experience has also equipped
              me with expertise in the SDLC process as well as frontend and
              backend development.
            </p> */}
            <p>
              My favorite languages for systems programming, software
              engineering, and data analysis.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech:</span>
              {labelsFirst.map((label, index) => (
                <Chip
                  key={index}
                  className="chip"
                  label={label}
                />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon
              icon={faHtml5}
              size="3x"
            />
            <h3>Front-End</h3>
            {/* <p>
              Once the application is built, I help clients set up DevOps
              testing, CI/CD pipelines, and deployment automation to support the
              successful Go-Live.
            </p> */}
            <p>
              My preferred technologies for front-end web development and
              component design.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech:</span>
              {labelsSecond.map((label, index) => (
                <Chip
                  key={index}
                  className="chip"
                  label={label}
                />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon
              icon={faNode}
              size="3x"
            />
            <h3>Back-End</h3>
            {/* <p>
              Stay relevant in the market by leveraging the latest AI models in
              your projects. I have professional experience building enterprise
              grade GenAI-enabled solutions to empower intelligent decision
              making.
            </p> */}
            <p>
              My preferred technologies for back-end web programming and
              database architecture.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsThird.map((label, index) => (
                <Chip
                  key={index}
                  className="chip"
                  label={label}
                />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon
              icon={faTools}
              size="3x"
            />
            <h3>Tools</h3>
            {/* <p>
              Stay relevant in the market by leveraging the latest AI models in
              your projects. I have professional experience building enterprise
              grade GenAI-enabled solutions to empower intelligent decision
              making.
            </p> */}
            <p>
              My favorite tools for version control, code editing, and container
              orchestration.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFourth.map((label, index) => (
                <Chip
                  key={index}
                  className="chip"
                  label={label}
                />
              ))}
            </div>
          </div>
          <div className="skill">
            <FontAwesomeIcon
              icon={faCloud}
              size="3x"
            />
            <h3>Cloud Platforms</h3>
            {/* <p>
              Stay relevant in the market by leveraging the latest AI models in
              your projects. I have professional experience building enterprise
              grade GenAI-enabled solutions to empower intelligent decision
              making.
            </p> */}
            <p>
              The cloud services I use for deployment and hosting. 
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFifth.map((label, index) => (
                <Chip
                  key={index}
                  className="chip"
                  label={label}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
